/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from "react";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import { useQuery } from "@tanstack/react-query";
// import getHospitalData from './getHospitalData';
// import HospitalDataTable from './HospitalDataTable';
// import HospitalSelectedDetails from './HospitalSelectedDetails';
import { Bold, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import Sheet from "../common/Sheet";
import SheetForm from "../common/Sheet";
import getHospitalData from "../hospital/getHospitalData";
import getApiData from "./getApiData";
import ApiSelectedDetails from "./ApiSelectedDetails";
import ApiDataTable from "./ApiDataTable";
import TokenLedgerDetails from "./TokenLedgerDetails";
// import HospitalCreateForm from './HospitalCreateForm';

export default function ApiComp({ isOpen, activeTab }) {
  const [selected, setSelected] = React.useState(null);

  const { data: hospital, isFetching: ishospitalFetching } = useQuery({
    queryKey: ["apis"],
    queryFn: getApiData,
    refetchIntervalInBackground: true,
    refetchInterval: 300000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  const createHospital = async () => {
    try {
      console.log("creating");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {activeTab === "Token Ledger" ? (
        <div className={`flex flex-col w-full ${isOpen ? "min-w-[80vw]" : "min-w-[94vw]"}`}>
          <div className="flex flex-row justify-between items-center w-full">
            <h2 style={{ fontWeight: "bolder" }} className="text-xl">
              Token Ledger
            </h2>
          </div>
          
          <div className="mt-[2vh] h-[83vh] w-full overflow-y-auto bg-background rounded-lg border p-4 shadow-sm">
            {ishospitalFetching && !hospital ? (
              <div className="flex h-full items-center justify-center">
                 <Loader2 className="animate-spin text-muted-foreground" size={32} />
              </div>
            ) : (
              <TokenLedgerDetails 
                 selected={selected} 
                 setSelected={setSelected} 
                 hospitalList={hospital} 
                 isGlobalView={true} 
              />
            )}
          </div>
        </div>
      ) : (
        <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h2 style={{ fontWeight: "bolder" }} className="text-xl">
          API Details
        </h2>
        {/* <Button onClick={() => setAddHospitalSheet(true)}>+ Add Hospital</Button> */}
      </div>

      <div className="mt-[2vh] rounded h-[83vh] ">
        <ResizablePanelGroup
          direction="horizontal"
          className={`max-w-md rounded-lg border ${isOpen ? "min-w-[80vw]" : "min-w-[94vw]"}`}
        >
          <ResizablePanel defaultSize={50} minSize={40}>
            {/* <div className="flex h-full items-center justify-center p-6">
                    <span className="font-semibold">Sidebar</span>
                    </div> */}
            <ApiDataTable
              selected={selected}
              setSelected={setSelected}
              hospitalData={hospital}
              ishospitalFetching={ishospitalFetching}
            />
          </ResizablePanel>
          <ResizableHandle withHandle />
          <ResizablePanel defaultSize={50} minSize={50}>
            <ApiSelectedDetails selected={selected} setSelected={setSelected} activeTab={activeTab} />
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>

      {/* <SheetForm 
            open={addHospitalSheet}
            close={setAddHospitalSheet}
            title="Add Hospital"
            description="Create a new hospital/Clinic"
            component={<HospitalCreateForm setAddHospitalSheet={setAddHospitalSheet}/>}
            action={createHospital}

            // setOpen={setAddHospitalSheet}
        /> */}
        </>
      )}
    </div>
  );
}
